<script setup lang="ts">
import { AkIcon, AkParagraph, AkRoundedButton } from '@ankorstore/design-system';

withDefaults(defineProps<{ isFocused: boolean; withTooltip?: boolean }>(), {
  withTooltip: true,
});
defineEmits(['click']);
</script>

<template>
  <AkRoundedButton
    class="recommended-products-button"
    :is-focused="isFocused"
    @click="$emit('click')"
  >
    <template
      v-if="withTooltip"
      #tooltip="{ click }"
    >
      <AkParagraph
        class="recommended-products-button__tooltip"
        size="base"
        @click="click"
      >
        {{ $t('discovery.recommendations.similar_products.drawer.button.msg') }}
      </AkParagraph>
    </template>
    <template #default>
      <AkIcon
        class="recommended-products-button__icon"
        size="md"
        symbol="stars"
      />
    </template>
  </AkRoundedButton>
</template>

<style scoped lang="scss">
@use '@css/abstracts/design-tokens' as d;
.recommended-products-button {
  $root: &;
  &:hover {
    #{$root}__icon {
      color: d.getColor('hot-pink');
    }
  }
  &__tooltip {
    padding-right: 0.25rem;
    cursor: pointer;
    user-select: none;
    color: theme('colors.neutral.900');
    text-decoration: underline;
    &:hover {
      color: theme('colors.neutral.700');
    }
  }
}
</style>
